import { type FunctionComponent } from "react";
import clsx from "clsx";
import type { PubUserType } from "~/database/user.model";

interface UserCountProps {
  user: PubUserType;
  setFollowerModalOpen: (open: boolean) => void;
  setFollowModalOpen: (open: boolean) => void;
}

const UserCount: FunctionComponent<
  UserCountProps
> = ({
  user,
  setFollowerModalOpen,
  setFollowModalOpen,
}) => {
  return (
    <div
      className={clsx(
        "flex",
        "items-center",
        "gap-10",
        "col-[1/2]",
      )}
    >
      {[
        {
          num: user.public_posts_count,
          text: "プレスリリース",
        },
        /* {
          num: user.posts_likes_count,
          text: "ブックマーク",
        }, */
        /*     {
          num: user.followers_count,
          text: "フォロワー",
          onClick: () => {
            setFollowerModalOpen(true);
          },
        },
        {
          num: user.following_count,
          text: "フォロー",
          onClick: () => {
            setFollowModalOpen(true);
          },
        }, */
      ].map((el) => {
        return (
          <div
            key={el.text}
            className={clsx(
              "flex items-center",
              "font-bold",
              "text-20",
              "max-md:text-15",
              "gap-4",
              //              el.onClick && "cursor-pointer",
            )}
            //          onClick={el.onClick}
          >
            {el.num}
            <div
              className={clsx(
                "text-gray-400",
                "font-normal",
                "text-13",
                "max-md:text-10",
              )}
            >
              {el.text}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserCount;
